export default __webpack_public_path__ + "static/media/in.e8492927.svg";